import React, { useEffect, useRef, useState } from "react";
import AppHeader from "./AppHeader";
import AppSideBar from "./AppSideBar";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { Badge, CircularProgress } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { loginLogo } from "../../assets";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useUserData } from "../../Hooks/App_Context";
import { ChatMain } from "./ChatMain";
import { _Make_Count_Zero } from "../../DAL/Listing/Chat";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: -1000,
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
  },
}));

export default function DashboardLayout() {
  const classes = useStyles();
  const chatRef = useRef(null);
  const [isChatSelected, setIsChatSelected] = useState(false);
  const [isChatInitiated, setIsChatInitiated] = useState(false);
  const pathname = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [chats, setChats] = useState([]);
  const [userList, setUserList] = useState([]);
  const [endChat, setEndChat] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [messageId, setMessageId] = useState(null);
  const [selectChat, setSelectChat] = useState(null);
  const [sendMessagesLoader, setSendMessagesLoader] = useState(false);
  const [delLoading, setDelLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const selectChatRef = useRef(selectChat);
  const {
    setUnreadMessageCount,
    unreadMessageCount,
    isNewMessage,
    setisNewMessage,
  } = useUserData();
  const [chatList, setChatList] = useState(
    tabValue === 0
      ? chats
      : tabValue === 1
      ? endChat
      : tabValue === 2
      ? userList
      : null
  );

  // Toggle mobile chat drawer open/close state
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const makeCountZero = async (chatId) => {
    const response = await _Make_Count_Zero(chatId);
    if (response.status === 200) {
      // setUnreadMessageCount(chatId);
      // setisNewMessage(false);
    }
  };

  // Reset chat-related states when overlay is clicked (closes chat)
  const handleOverlayClick = () => {
    makeCountZero(selectChat?._id);
    setIsChatSelected(false);
    setisNewMessage(false);
    setChatOpen(false);
    setTabValue(0);
    setSelectChat(null);
  };

  // Keep the latest selected chat in a ref to access it outside React's re-render cycle
  useEffect(() => {
    selectChatRef.current = selectChat;
  }, [selectChat]);

  // Open chat window automatically when a new message is flagged
  useEffect(() => {
    if (isNewMessage) {
      setChatOpen(true);
    }
  }, [isNewMessage, setisNewMessage]);

  // Close the mobile chat drawer whenever the route/path changes
  useEffect(() => {
    setMobileOpen(false);
  }, [pathname]);

  // Prevent page scrolling when the chat window is open
  useEffect(() => {
    if (chatOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [chatOpen]);

  // Close chat when clicking outside of the chat component
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (chatRef.current && !chatRef.current.contains(event.target)) {
        setChatOpen(false);
        setisNewMessage(false);
      }
    };

    if (chatOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [chatOpen]);

  // Track changes in unread message count (log or use elsewhere if needed)
  useEffect(() => {
    console.log("Unread message count:", unreadMessageCount);
  }, [unreadMessageCount, setUnreadMessageCount]);

  if (isLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <Helmet>
        <title>{"Admin | MediaGlobe"}</title>
        <meta name="description" content={"Admin | MediaGlobe"} />
        <link rel="icon" href={loginLogo} />
      </Helmet>

      <div className="live_chat">
        <div className="for_icon" onClick={() => setChatOpen(!chatOpen)}>
          {chatOpen ? (
            <KeyboardArrowDownIcon />
          ) : (
            <div className="icon_main position-relative">
              <Badge
                badgeContent={unreadMessageCount}
                color="error"
                max={50}
                sx={{
                  "& .MuiBadge-badge": {
                    lineHeight: "13px",
                    fontSize: "10px",
                  },
                }}
              >
                <SupportAgentIcon fontSize="large" />
              </Badge>
            </div>
          )}
        </div>

        {chatOpen && (
          <div className={classes.overlay} onClick={handleOverlayClick} />
        )}
        <ChatMain
          handleOverlayClick={handleOverlayClick}
          classes={classes}
          selectChatRef={selectChatRef}
          open={chatOpen}
          handleClose={() => handleOverlayClick()}
          isChatSelected={isChatSelected}
          setIsChatSelected={setIsChatSelected}
          setIsChatInitiated={setIsChatInitiated}
          isChatInitiated={isChatInitiated}
          selectChat={selectChat}
          setMessageId={setMessageId}
          messageId={messageId}
          setSelectChat={setSelectChat}
          sendMessagesLoader={sendMessagesLoader}
          setSendMessagesLoader={setSendMessagesLoader}
          delLoading={delLoading}
          setDelLoading={setDelLoading}
          tabValue={tabValue}
          setChatList={setChatList}
          setUserList={setUserList}
          setEndChat={setEndChat}
          setChats={setChats}
          userList={userList}
          chatList={chatList}
          setTabValue={setTabValue}
          openDelete={openDelete}
          setOpenDelete={setOpenDelete}
        />
      </div>
      <div className="d-flex position-relative">
        <AppHeader
          handleDrawerToggle={handleDrawerToggle}
          setIsLoading={setIsLoading}
        />
        <AppSideBar
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
        />
      </div>
    </>
  );
}
